export interface PmmRoleClaims {
  pmm_user: boolean
  pmm_owner_coach: boolean
  pmm_role_version: number
  pmm_partner: boolean
  pmm_partner_role_version: number
}

export interface PmmSession {
  uid: string
  email: string
  displayName: string
  authTime: number
  tokenIssuedAt: number
  claims: PmmRoleClaims
  accountState: 'active' | 'deletion_pending' | 'suspended'
  partnerAccountState: 'active' | 'suspended' | 'none'
}

export function hasUserAccess(session: PmmSession | null): session is PmmSession {
  return Boolean(session?.claims.pmm_user && session.accountState === 'active')
}

export function hasPartnerAccess(session: PmmSession | null): boolean {
  return Boolean(session?.claims.pmm_partner && session.partnerAccountState === 'active'
    && Number.isInteger(session.claims.pmm_partner_role_version)
    && session.claims.pmm_partner_role_version > 0)
}

export function hasOwnerCoachCapability(session: PmmSession | null): boolean {
  return hasUserAccess(session)
    && session.claims.pmm_owner_coach
    && Number.isInteger(session.claims.pmm_role_version)
    && session.claims.pmm_role_version > 0
}

export function hasRecentAuthentication(session: PmmSession, nowSeconds = Date.now() / 1000, maximumAgeSeconds = 300): boolean {
  const ageSeconds = nowSeconds - session.authTime
  return ageSeconds >= -60 && ageSeconds <= maximumAgeSeconds
}
